import React from 'react'
import { makeStyles } from '@material-ui/core'
import LongLeaf from '../../assets/images/longLeaf.png'

const useStyles = makeStyles((theme) => ({
  imageStyle: {
    width: '116px',
    height: '61px',
    [theme.breakpoints.up('md')]: {
      width: '195.8px',
      height: '112.8px'
    },
    [theme.breakpoints.up('lg')]: {
      width: '198.3px',
      height: '110.3px',
      paddingTop: '17px'
    }
  }
}))

export default () => {
  const classes = useStyles()
  return <img src={LongLeaf} alt="" className={classes.imageStyle} />
}

